import * as corgi from 'external/dev_april_corgi+/js/corgi';

import {ScriptType, ScriptValue} from './types/data';

import {State, ScriptEditorController} from './script_editor_controller';

export function makeScriptEditor({
  type,
  value,
  onUpdate,
}: {
  type: ScriptType;
  value: ScriptValue;
  onUpdate: (value: ScriptValue) => void;
}) {
  return <ScriptEditor type={type} value={value} onUpdate={onUpdate} />;
}

export function ScriptEditor(
  {
    type,
    value,
    onUpdate,
  }: {
    type: ScriptType;
    value: ScriptValue;
    onUpdate: (value: ScriptValue) => void;
  },
  state: State | undefined,
  updateState: (newState: State) => void,
) {
  if (!state) {
    state = {
      error: undefined,
    };
  }

  return (
    <>
      <div
        js={corgi.bind({
          controller: ScriptEditorController,
          args: {type, onUpdate, value},
          events: {render: 'wakeup'},
          state: [state, updateState],
        })}
        className="bg-neutral-800 max-h-[inherit] overflow-y-auto p-4 text-sm rounded"
      >
        <textarea
          className="font-mono h-64 p-1 w-[48rem]"
          unboundEvents={{focusout: 'changed', keyup: 'changed'}}
          value={value.value}
        />
        <div className="flex group">
          <div
            className={
              'h-8 p-2 relative rounded-full w-8 ' +
              (state.error ? 'bg-red-400' : 'bg-green-400')
            }
          >
            <span
              className={
                'absolute select-none start-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2'
              }
            >
              {state.error ? 'x' : '✓'}
            </span>
          </div>
          <div className="hidden group-hover:block">
            <pre className="absolute bg-neutral-700 p-2 rounded">
              {state.error ?? 'Valid'}
            </pre>
          </div>
        </div>
      </div>
    </>
  );
}
